// /* global $ */
/* eslint no-inner-declarations: 0 */

// import { gup } from '../helpers/params';

// // BSD sourcing
// const source = gup('utm_source') || gup('source');

// // adds sourcing field to BSD forms based on any source in the url
// $(document).ready(() => {
//   if (source) {
//     $.$body.find('.bsd-form').each(function() {
//       const $form = $(this);
//       if ($form.find('[name="source"]').length) {
//         $form.find('[name="source"]').val(source);
//       } else {
//         $('<input/>', {
//           type: 'hidden',
//           name: 'source',
//           value: source,
//         }).appendTo($form);
//       }
//     });
//   }
// });

/**
 * Action Network defer script.
 * Intersection observer loads script when within 360px of module.
 */
const loadEAScript = () => {
  const eaEl = document.querySelector('.module__every-action');
  if (typeof eaEl !== 'undefined' && eaEl !== null) {
    // Add loading class.
    eaEl.classList.add('is-loading');

    // Setup IO.
    const observeEaModule = () => {
      const options = {
        rootMargin: '360px',
        threshold: 0,
      };
      const handleIntersect = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Lazy-load script.
            document
              .querySelector('#ea_embed_js')
              .setAttribute(
                'src',
                document.querySelector('#ea_embed_js').getAttribute('data-src'),
              );
            // Stop observing.
            observer.unobserve(entry.target);
          }
        });
      };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(eaEl);
    };
    observeEaModule();
  }
};
loadEAScript();
